import {
    GET_JOB_TITLE_GRID_DATA,
    SET_JOB_TITLE_GRID_DATA,
    GET_JOB_TITLE_EXCEL_DATA,
    SET_JOB_TITLE_EXCEL_DATA,
    GET_SAVE_JOB_TITLE,
    IS_JOB_TITLE_SAVED,
    GET_EDIT_JOB_TITLE_DATA_BY_ID,
    SET_EDIT_JOB_TITLE_DATA_BY_ID,
    GET_SAVE_MULTIPLE_JOB_TITLE_STATUS,
    SET_SAVE_MULTIPLE_JOB_TITLE_STATUS
} from "./JobTitleType"

const getJobTitleGridData = (payload: any) => ({
    type: GET_JOB_TITLE_GRID_DATA,
    payload
});

const setJobTitleGridData = (jobTitleGridData: any) => ({
    type: SET_JOB_TITLE_GRID_DATA,
    jobTitleGridData: jobTitleGridData
});

const getJobTitleExcelData = (payload: any) => ({
    type: GET_JOB_TITLE_EXCEL_DATA,
    payload
});

const setJobTitleExcelData = (jobTitleExcelData: any) => ({
    type: SET_JOB_TITLE_EXCEL_DATA,
    jobTitleExcelData: jobTitleExcelData
});

const getSaveJobTitle = (payload: any) => ({
    type: GET_SAVE_JOB_TITLE,
    payload
});

const setIsJobTitleSaved = (isJobTitleSaved: any) => ({
    type: IS_JOB_TITLE_SAVED,
    isJobTitleSaved: isJobTitleSaved
});

const getEditJobTitleData = (payload: any) => ({
    type: GET_EDIT_JOB_TITLE_DATA_BY_ID,
    payload
});

const setEditJobTitleData = (editJobTitleDataById: any) => ({
    type: SET_EDIT_JOB_TITLE_DATA_BY_ID,
    editJobTitleDataById: editJobTitleDataById
});

const getSaveMultipleJobTitleStatus = (payload: any) => ({
    type: GET_SAVE_MULTIPLE_JOB_TITLE_STATUS,
    payload
});

const setSaveMultipleJobTitleStatus = (isSavedMultipleJobTitleStatus: any) => ({
    type: SET_SAVE_MULTIPLE_JOB_TITLE_STATUS,
    isSavedMultipleJobTitleStatus: isSavedMultipleJobTitleStatus
});

export {
    getJobTitleGridData,
    setJobTitleGridData,
    getJobTitleExcelData,
    setJobTitleExcelData,
    getSaveJobTitle,
    setIsJobTitleSaved,
    getEditJobTitleData,
    setEditJobTitleData,
    getSaveMultipleJobTitleStatus,
    setSaveMultipleJobTitleStatus
}
